export const OrderSaveConfirmationDialogMessages = {
    modalTitle: 'Order Status Change Confirmation',
    modalContent:
        "Changes to the order may not be saved with this status. Press SAVE to save the status change only or CANCEL to return to the order and save the changes you've made.",
    modalPrimaryActionTitle: 'Save',
} as const;
